import EditDemandRegContent from './EditDemandRegContent'
import DemandContextProvider from '../../../context/demand-context'

function EditDemandContextWrapper(props) {
    return (
        <DemandContextProvider>
            <EditDemandRegContent/>
        </DemandContextProvider>
    )
}

export default EditDemandContextWrapper 